<template>
  <el-dialog
    title="图片信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="small"
    >
      <el-form-item
        prop="advTitle"
        label="图片标题"
        :rules="[{ required: true, message: '不能为空'}]"
      >

        <el-select
                class="filter-item"
                v-model="form.advTitle"
                placeholder="请选择分类"
        >
          <el-option
                  v-for="item in ztOptionsall"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="type"
              label="类型"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.type"
                placeholder="请选择分类"
        >
          <el-option
                  v-for="item in ztOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="advUrl"
        label="图片链接"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.advUrl"></el-input>
      </el-form-item>
      <el-form-item
              prop="advPos"
              label="图片编号"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.advPos"></el-input>
      </el-form-item>
      <el-form-item
        prop="advSort"
        label="排序"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.advSort"></el-input>
      </el-form-item>
      <el-form-item
              prop="media_type"
              label="媒体类型"

      >
        <el-radio v-model="form.media_type" label="1"  @change="changeHandler(1)">图片</el-radio>
        <el-radio v-model="form.media_type" label="2" @change="changeHandler(2)">视频</el-radio>
        <el-radio v-model="form.media_type" label="3" @change="changeHandler(3)">音频</el-radio>
      </el-form-item>
      <el-form-item
              prop="advNote"
              label="图片内容"
      >
        <el-input v-model="form.advNote"></el-input>
      </el-form-item>
      <el-form-item label="图片" prop="advImg"   v-if="TB1"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.advImg" style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove"
                :on-success="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
        建议尺寸200*200像素，大小1M以内，支持jpg、png、jpeg格式
      </el-form-item>

      <el-form-item   label="视频" prop="advImg"  v-if="TB2" :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.advImg" style="display:none"></el-input>
        <el-upload class="avatar-uploader"
                   :action="videoUrl"
                   v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                   v-bind:on-progress="uploadVideoProcess"
                   v-bind:on-success="handleVideoSuccess"
                   v-bind:before-upload="beforeUploadVideo"
                   v-bind:show-file-list="true">
          <video v-if="form.showVideoPath !='' && !videoFlag"
                 v-bind:src="form.showVideoPath"
                 class="avatar video-avatar"
                 controls="controls"  style="width: 500px;height: 500px; ">
            您的浏览器不支持视频播放
          </video>
          <i v-else-if="form.showVideoPath =='' && !videoFlag"
             class="el-icon-plus avatar-uploader-icon"></i>
          <el-progress v-if="videoFlag == true"
                       type="circle"
                       v-bind:percentage="videoUploadPercent"
                       style="margin-top:7px;"></el-progress>
        </el-upload>
        <div>最多可以上传1个视频，建议大小50M，推荐格式mp4</div>
      </el-form-item>

      <el-form-item   label="音频" prop="advImg"  v-if="TB3" :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.advImg" style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="audio/mp3,image/jpg,audio/mpeg"
                :limit=1
                :auto-upload="true"
                :file-list="fileList"
                :before-upload="handleBeforeUploadyp"
                :on-remove="handleRemove"
                :on-success="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
          <audio controls ref="audio" v-if="mp3url !=''"　class="aud">

            <source :src="mp3url" />

          </audio>
        </el-upload>
        <div>最多可以上传1个视频，建议大小20M，推荐格式mp3</div>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as agentService from '@/api/sys/agent'
import util from '@/libs/util.js'
export default {
  name: 'smallposterEditForm',
  props: {
    oneclass: Object,
    value: Boolean
  },
  data () {
    return {
      imgUrl: process.env.VUE_APP_API + '/moblieapp/currencyUpload',
      videoUrl: process.env.VUE_APP_API + '/moblieapp/videoUpload',
      formEdit: true,
      loading: false,
      TB2: false,
      TB3: false,
      TB1: true,
      dialogVisible: false,
      videoFlag: false,
      mp3url: '',
      // 是否显示进度条
      videoUploadPercent: '',
      // 进度条的进度，
      isShowUploadVideo: false,
      fileList: [],
      ztOptionsall: [
        {
          value: '出行安全',
          label: '出行安全'
        },
        {
          value: '招财进宝',
          label: '招财进宝'
        },
        {
          value: '感情姻缘',
          label: '感情姻缘'
        },
        {
          value: '情绪管理',
          label: '情绪管理'
        },
        {
          value: '商务洽谈',
          label: '商务洽谈'
        },
        {
          value: '约人求见',
          label: '约人求见'
        },
        {
          value: '工作事业',
          label: '工作事业'
        },
        {
          value: '健康管理',
          label: '健康管理'
        },
        {
          value: '求学考试',
          label: '求学考试'
        },
        {
          value: '修造搬家',
          label: '修造搬家'
        },
        {
          value: '求子备孕',
          label: '求子备孕'
        },
        {
          value: '桃花情缘',
          label: '桃花情缘'
        }
      ],
      ztOptions: [
        {
          value: '0',
          label: '凶'
        },
        {
          value: '1',
          label: '小吉'
        },
        {
          value: '2',
          label: '中吉'
        },
        {
          value: '3',
          label: '大吉'
        }
      ],
      form: {
        media_type: '1',
        showVideoPath: '',
        advImg: ''
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      if (this.oneclass.id) {
        // userService.getUser(this.user.id).then(data => {
        let form = {}
        form.advTitle = this.oneclass.advTitle
        form.type = this.oneclass.type
        form.advUrl = this.oneclass.advUrl
        form.advPos = this.oneclass.advPos
        form.advSort = this.oneclass.advSort
        form.advNote = this.oneclass.advNote
        form.media_type = this.oneclass.media_type
        if (this.oneclass.media_type == 2) {
          if (this.oneclass.advImg != null && this.oneclass.advImg != '') {
            form.showVideoPath = 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.oneclass.advImg
            form.advImg = this.oneclass.advImg
          }
          this.TB1 = false
          this.TB2 = true
          this.TB3 = false
        } else if (this.oneclass.media_type == 3) {
          if (this.oneclass.advImg != null && this.oneclass.advImg != '') {
            this.mp3url = 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.oneclass.advImg
            form.advImg = this.oneclass.advImg
          }
          this.TB1 = false
          this.TB2 = false
          this.TB3 = true
        } else {
          this.TB1 = true
          this.TB2 = false
          this.TB3 = false
          if (this.oneclass.advImg != null && this.oneclass.advImg != '') {
            form.advImg = this.oneclass.advImg
            this.fileList = [{ url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.oneclass.advImg }]
          }
        }

        this.form = form
        // });
        this.formEdit = true
      } else {
        this.formEdit = true
        this.fileList = []
        this.form = {}
        this.form.advUrl = 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/'
        this.form.media_type = '1'
      }
    },
    handleSelectChange (type) {
      if (type == '3' || type == '4') {
        this.isholiday = true
        var formData2 = new FormData() // 声明一个FormData对象
        formData2.append('type', type)
        agentService.getIsholiday(formData2).then(data => {
          this.typeOptions = data
        })
      } else {
        this.isholiday = false
      }
    },
    changeHandler (value) {
      if (value == 1) {
        this.TB1 = true
        this.TB2 = false
        this.TB3 = false
      } else if (value == 3) {
        this.TB3 = true
        this.TB2 = false
        this.TB1 = false
      } else {
        this.TB1 = false
        this.TB2 = true
        this.TB3 = false
      }
    },
    // 上传文件之前的钩子
    handleBeforeUpload (file) {
      let isJPG = true
      // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
      console.log('before')
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        isJPG = false
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        })
      }
      let size = file.size / 1024 / 1024 / 2
      if (size > 2) {
        this.$notify.warning({
          title: '警告',
          message: '图片大小必须小于2M'
        })
        isJPG = false
      }

      return isJPG // 返回false不会自动上传
    },
    handleBeforeUploadyp (file) {
      let isJPG = true
      // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
      console.log('before')
      if (!(file.type === 'audio/mp3' || file.type === 'audio/mpeg')) {
        isJPG = false
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为audio/mp3, audio/mpeg的音频文件'
        })
      }
      let size = file.size / 1024 / 1024 / 1
      if (size > 20) {
        this.$notify.warning({
          title: '警告',
          message: '音频文件大小必须小于20M'
        })
        isJPG = false
      }

      return isJPG // 返回false不会自动上传
    },
    // 文件超出个数限制时的钩子
    handleExceed (files, fileList) {

    },
    // 文件列表移除文件时的钩子
    handleRemove (file, fileList) {
      this.form.advImg = ''
      this.dialogVisible = true
    },
    // 上传前回调
    beforeUploadVideo (file) {
      var fileSize = file.size / 1024 / 1024 < 50
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
        this.$notify.warning({
          title: '警告',
          message: '请上传正确的视频格式'
        })
        return false
      }
      if (!fileSize) {
        this.$notify.warning({
          title: '警告',
          message: '视频大小不能超过50MB'
        })
        return false
      }
      this.isShowUploadVideo = false
    },
    // 进度条
    uploadVideoProcess (event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    // 上传成功回调
    handleVideoSuccess (res, file) {
      this.isShowUploadVideo = true
      this.videoFlag = false
      this.videoUploadPercent = 0

      // 前台上传地址
      /**  if (file.status == 'success' ) {
             this.form.showVideoPath = file.url;;
          } else {
              this.$notify.warning({
                  title: '警告',
                  message: '上传失败，请重新上传'
              })
        }**/
      // 后台上传地址

      if (res.code == 200) {
        alert('视频上传成功')
        // this.form.showVideoPath = "https://szqykj-1307293036.cos.ap-guangzhou.myqcloud.com/"+res.url;
        this.form.advImg = res.url
      } else {
        this.$notify.warning({
          title: '警告',
          message: res.msg
        })
      }
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview (file) {
      console.log('url===' + file.url)
      this.form.advImg = file.url
      this.dialogVisible = true
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          agentService.saveSmallPoster({ ...this.form, agentid: util.cookies.get('agentid'), xt_id: util.cookies.get('xt_id'), id: this.oneclass.id })
            .then(data => {
              this.loading = false
              this.dialogVisible = false
              this.$emit('submit')
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
